import { LocationSuggestion } from "@/types/location";

export const fetchLocationSuggestions = async (query: string): Promise<LocationSuggestion[]> => {
  // Check if Google Maps API is available
  if (!window.google || !window.google.maps || !window.google.maps.places) {
    throw new Error("Google Maps Places API not loaded");
  }

  return new Promise((resolve, reject) => {
    try {
      const autocompleteService = new window.google.maps.places.AutocompleteService();
      
      autocompleteService.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: "in" },
        },
        (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            reject(new Error(`Places API error: ${status}`));
            return;
          }

          const validSuggestions = predictions.map((prediction) => ({
            description: prediction.description.replace(", India", ""),
            place_id: prediction.place_id,
          }));

          resolve(validSuggestions);
        }
      );
    } catch (error) {
      reject(error);
    }
  });
};